<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent width="800">
        <v-card class="mt-3 pa-1">
            <Title :title="targetMeasureItem == null ? '新しい測定項目' : targetMeasureItem.body.name + 'の編集'">
                <v-spacer />
                <TitleButton
                    icon="mdi-floppy"
                    name="保存"
                    @click="onClickSave()" />
                <TitleButton
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <v-container fluid>
                    <v-row align="baseline">
                        <v-col cols="12" class="pt-0 pb-0">
                            <v-switch
                                v-model="editItems.auto" 
                                dense
                                label="自動測定"
                                outlined
                                persistent-hint
                                hide-details
                                class="pb-2" />
                        </v-col>
                    </v-row>
                    <template v-if="!editItems.auto">
                        <v-row >
                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                <v-text-field
                                    v-model="editItems.name"
                                    dense
                                    clearable
                                    hide-details
                                    label="測定項目の名称"
                                    item-text="text"
                                    outlined />
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col cols="6" xs="6" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                    v-model="editItems.unit" 
                                    dense
                                    clearable
                                    label="単位"
                                    item-text="text"
                                    hide-details
                                    outlined />
                            </v-col>
                            <v-col cols="6" xs="6" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                    v-model.number="editItems.step" 
                                    dense
                                    clearable
                                    label="測定単位"
                                    item-text="text"
                                    hide-details
                                    outlined />
                            </v-col>
                            <v-col cols="6" xs="6" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                    v-model.number="editItems.min" 
                                    dense
                                    clearable
                                    label="最小値"
                                    item-text="text"
                                    outlined
                                    hide-details
                                    append-outer-icon="mdi-dots-horizontal" />
                            </v-col>
                            <v-col cols="6" xs="6" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                    v-model.number="editItems.max" 
                                    dense
                                    clearable
                                    label="最大値"
                                    item-text="text"
                                    hide-details
                                    outlined />
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else>
                        <v-row>
                            <v-col>
                                <v-select
                                    v-model="editItems.boxIdentificationCode"
                                    :items="boxes"
                                    item-text="box.name"
                                    item-value="box.boxIdentificationCode"
                                    label="環境ボックス"
                                    hide-details />
                            </v-col>
                            <v-col v-if="editItems.boxIdentificationCode != null">
                                <v-select
                                    v-model="editItems.sensorKey"
                                    :items="selectedBoxSensors"
                                    item-text="body.name"
                                    item-value="body.sensorKey"
                                    label="センサー"
                                    hide-details />
                            </v-col>
                        </v-row>
                    </template>
                </v-container>
            </v-card-text>
        </v-card>
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        components: {
            Title,
            TitleButton,
            Confirm
        },
        props: {
            /** 対象の場所 */
            place: null,
            /** 全測定項目 */
            measureItems: null,
            /** ユーザーに設定されている全環境ボックス */
            boxes: null
        },
        computed: {
            selectedBoxSensors: function () {
                if (this.editItems.boxIdentificationCode == null) {
                    return null
                }
                const box = this.boxes.find((v)=>v.box.boxIdentificationCode == this.editItems.boxIdentificationCode)
                return box.sensors
            }
        },
        data: function () {
            return {
                isView: false,
                /**
                 * 編集項目
                 */
                editItems: {
                    name: "",
                    auto: true,
                    unit: "",
                    step: 1,
                    min: 0,
                    max: 100,
                    boxIdentificationCode: null,
                    sensorKey: null
                },
                /**
                 * 編集対象の測定項目
                 * {
                 *     body: 実体,
                 *     isVisible: 環境チャートに表示するか否か, 
                 *     viewAxis: 1 or 2 表示するY軸
                 *     histories: {
                 *         年月: {
                 *             日:測定データ
                 *         }
                 *     }
                 * }
                 */
                targetMeasureItem: null,
            }
        },
        methods: {
            /**
             * 保存ボタン押下時
             */
            onClickSave: function () {
                console.log(this.editItems)
                const self = this
                this.$refs.confirm.show({
                    title: "測定項目の登録",
                    message: "測定項目を登録しますか？",
                    buttonYes: "登録する",
                    buttonNo: "いいえ",
                    width: 400,
                    listenerYes: function () {
                        self.regist()
                        self.mode = "select"
                        return true
                    },
                })
            },
            /**
             * 登録処理
             */
            regist: function () {
                const self = this
                const userUID = this.$store.getters["userUID"]
                var measureItem = (this.targetMeasureItem == null ? null : this.targetMeasureItem.body)
                if (measureItem == null) {
                    const newID = this.measureItems.length + 1
                    measureItem = {
                        version: "1.0.0",
                        placeID: this.place.body.placeID,
                        measureItemID: newID,
                        data: null,
                        register: {
                            userUID: this.$store.getters["loggedInUserUID"],
                            dateTime: this.df_currentDateTime()
                        },
                        updater: {
                            userUID: "",
                            dateTime: ""
                        },
                    }
                } else {
                    measureItem.updater = {
                        userUID: this.$store.getters["loggedInUserUID"],
                        dateTime: this.df_currentDateTime()
                    }
                }
                measureItem.name = this.editItems.name
                measureItem.auto = this.editItems.auto
                measureItem.unit = this.editItems.unit
                measureItem.step = this.editItems.step
                measureItem.min = this.editItems.min
                measureItem.max = this.editItems.max

                measureItem.auto = this.editItems.auto

                if (measureItem.auto) {
                    measureItem.autoSetting = {
                        boxIdentificationCode: this.editItems.boxIdentificationCode,
                        sensorKey: this.editItems.sensorKey
                    }
                } else {
                    measureItem.autoSetting = null
                }

                console.log(measureItem)
                
                db.collection("users").doc(userUID).collection("places").doc(""+measureItem.placeID).collection("environments").doc(""+measureItem.measureItemID).set(measureItem).then(function(){
                    self.$store.commit("notification", {message:"測定項目を登録しました。", isError:false})
                    if (self.targetMeasureItem == null) {
                        self.measureItems.push(
                            {
                                body: measureItem,
                                isVisible: true,
                                viewAxis: 1,
                                histories: {}
                            }
                        )
                    }
                    self.isView = false
                }).catch(function(error){
                    console.log(error)
                    self.$store.commit("notification", {message:"測定項目の登録に失敗しました。", isError:true})
                })
            },
            /**
             * このダイアログを表示
             */
            show: function (measureItem) {
                console.log(measureItem)
                this.targetMeasureItem = measureItem

                if (measureItem != null) {
                    this.editItems = {
                        name: measureItem.body.name,
                        auto: measureItem.body.auto,
                        unit: measureItem.body.unit,
                        step: measureItem.body.step,
                        min: measureItem.body.min,
                        max: measureItem.body.max
                    }
                } else {
                    this.editItems = {
                        name: "",
                        auto: true,
                        unit: "",
                        step: 1,
                        min: 0,
                        max: 100
                    }
                }

                this.isView = true
            }
        }
    }
</script>
                editItems: {
                    name: "",
                    auto: false,
                    unit: "",
                    step: 1,
                    min: 0,
                    max: 100
                },
